import React from "react";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";
import useBelowBreakpoint from "core-web/hooks/useBelowBreakpoint";
import PageIntroBlock from "theme/libs/wordpress/content/cmsBlocks/PageIntroBlock";

const PageIntroModule = ({ content, breadcrumbs }) => {
    const isMobile = useBelowBreakpoint("tabletLg");
    const { t } = useTranslation();

    const moduleContent = content?.data ?? content;
    const { heading: headingObj, paragraph } = moduleContent || {};

    const device = headingObj?.customize_mobile && isMobile ? "mobile" : "desktop";
    const rawHeading = headingObj?.data?.[device]?.heading ?? headingObj?.data?.desktop?.heading;
    const extractedHeading = typeof rawHeading === "string" ? rawHeading : rawHeading?.text || rawHeading?.heading;
    const headingText = extractedHeading || t("articles.collection_hero_title");

    const hasParagraph = paragraph && Array.isArray(paragraph) && paragraph.length > 0;
    const paragraphFallback = !hasParagraph ? t("articles.collection_description") : null;

    return (
        <PageIntroBlock
            breadcrumbs={breadcrumbs}
            headingText={headingText}
            paragraph={hasParagraph ? paragraph : null}
            paragraphFallback={paragraphFallback}
        />
    );
};

PageIntroModule.propTypes = {
    breadcrumbs: PropTypes.arrayOf(PropTypes.object),
    content: PropTypes.shape({
        heading: PropTypes.object,
        paragraph: PropTypes.array,
    }),
};

PageIntroModule.defaultProps = {
    breadcrumbs: [],
    content: {},
};

export default PageIntroModule;
